
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/newsletter/subscribe",
      function () {
        return require("private-next-pages/[lang]/newsletter/subscribe/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/newsletter/subscribe"])
      });
    }
  